import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["children", "color", "imagePosition"];
import clsx from "clsx";
import React from "react";
import { createMemoClass } from "../create-memo-class";
import { Image } from '..';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var PullQuote = _ref => {
  var {
    children,
    color,
    imagePosition
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  var classes = usePullQuoteClass({
    color,
    imagePosition
  });
  return /*#__PURE__*/_jsx("div", _extends({
    className: classes
  }, rest, {
    children: children
  }));
};
var usePullQuoteClass = createMemoClass(props => {
  var colors = {
    primary: "pull-quote-primary",
    secondary: "pull-quote-secondary",
    tertiary: "pull-quote-tertiary",
    neutral: "pull-quote-neutral"
  };
  var imagePositions = {
    left: "",
    right: "pull-quote-reverse"
  };
  return clsx("pull-quote", colors[props.color], imagePositions == null ? void 0 : imagePositions[props.imagePosition]);
});

PullQuote.Image = _ref2 => {
  var {
    src,
    alt
  } = _ref2;
  return /*#__PURE__*/_jsx("div", {
    className: "pull-quote-image",
    children: /*#__PURE__*/_jsx(Image, {
      image: {
        filename: src,
        alt
      }
    })
  });
};

PullQuote.Content = _ref3 => {
  var {
    name,
    children
  } = _ref3;
  return /*#__PURE__*/_jsxs("div", {
    className: "pull-quote-content",
    children: [/*#__PURE__*/_jsxs("svg", {
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      className: "fill-current",
      width: "32",
      height: "32",
      viewBox: "0 0 32 32",
      children: [/*#__PURE__*/_jsx("title", {
        children: "quotes-left"
      }), /*#__PURE__*/_jsx("path", {
        d: "M7.031 14c3.866 0 7 3.134 7 7s-3.134 7-7 7-7-3.134-7-7l-0.031-1c0-7.732 6.268-14 14-14v4c-2.671 0-5.182 1.040-7.071 2.929-0.364 0.364-0.695 0.751-0.995 1.157 0.357-0.056 0.724-0.086 1.097-0.086zM25.031 14c3.866 0 7 3.134 7 7s-3.134 7-7 7-7-3.134-7-7l-0.031-1c0-7.732 6.268-14 14-14v4c-2.671 0-5.182 1.040-7.071 2.929-0.364 0.364-0.695 0.751-0.995 1.157 0.358-0.056 0.724-0.086 1.097-0.086z"
      })]
    }), /*#__PURE__*/_jsx("span", {
      className: "px-4",
      children: children
    }), /*#__PURE__*/_jsxs("svg", {
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      className: "float-right fill-current",
      width: "32",
      height: "32",
      viewBox: "0 0 32 32",
      children: [/*#__PURE__*/_jsx("title", {
        children: "quotes-right"
      }), /*#__PURE__*/_jsx("path", {
        d: "M25 20c-3.866 0-7-3.134-7-7s3.134-7 7-7 7 3.134 7 7l0.031 1c0 7.732-6.268 14-14 14v-4c2.671 0 5.182-1.040 7.071-2.929 0.364-0.364 0.695-0.75 0.995-1.157-0.357 0.056-0.724 0.086-1.097 0.086zM7 20c-3.866 0-7-3.134-7-7s3.134-7 7-7 7 3.134 7 7l0.031 1c0 7.732-6.268 14-14 14v-4c2.671 0 5.182-1.040 7.071-2.929 0.364-0.364 0.695-0.75 0.995-1.157-0.357 0.056-0.724 0.086-1.097 0.086z"
      })]
    }), /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx("strong", {
          children: name
        })
      })
    })]
  });
};
//# sourceMappingURL=pull_quote.js.map